import React, { useState } from 'react'

import TransferData from 'core/component/TransferData'
import { Modal } from 'antd'

const SrpSystemCodeTransfer = ({
  dataSource,
  visible,
  defaultTargetKeys = [],
  onOK,
}) => {
  const [targetKeys, setTargetKeys] = useState(defaultTargetKeys)

  return (
    <Modal
      title="Select System Code"
      visible={visible}
      onOk={_ => onOK(targetKeys)}
      onCancel={_ => onOK(defaultTargetKeys)}
      width={1000}
      // height={1000}
      top={20}
      style={{ width: '700px', height: '100px' }}
    >
      <TransferData
        titles={['System Code', 'Selected']}
        sortAfter
        showSearch={false}
        showSelectAll
        isRightListSelectionStoreRequired={false}
        dataSource={dataSource}
        rowKey={d => d.srpSystemcode}
        render={d => d.srpSystemcode + '-' + d.description}
        targetKeys={targetKeys}
        setTargetKeys={setTargetKeys}
        style={{
          display: 'grid',
          gridTemplateColumns: '400px 30px 400px',
          gridTemplateRows: '1fr',
          gridColumnGap: '10px',
          margin: '1px',
          // maxHeight: height - 220,
          // overflow: 'hide',
        }}
        listStyle={{
          height: 300,
          maxHeight: 300,
          width: '400px',
          margin: '5px',
        }}
        operationStyle={{
          alignSelf: 'center',
          justifySelf: 'center',
        }}
      />
    </Modal>
  )
}

export default SrpSystemCodeTransfer
